/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Summarize_ReportsInputs */



/**
* | output |
* | --- |
* | "Summarize long reports and PDFs" |
*
* @param {Onboarding_Usage_Summarize_ReportsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_summarize_reports = /** @type {((inputs?: Onboarding_Usage_Summarize_ReportsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Summarize_ReportsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lange Berichte und PDFs zusammenfassen")
	return /** @type {LocalizedString} */ ("Summarize long reports and PDFs")
});